<template>

    <div id="poolTable">
        <v-app>
            <v-toolbar flat color="white">
                <v-toolbar-title class="congatec-gray">MAC-Pools</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-text-field v-model="search"
                              id="pool_search_bar"
                              class="searchbar"
                              append-icon="search"
                              label="Search"
                              single-line
                              hide-details></v-text-field>

                <v-btn id="create_pool_button" class="text-none" v-if="createPool" color="success" @click.stop="createMacPool"><span
                        class="text-xs-left">Create MAC-Pool</span>
                </v-btn>
                <ShowMacPoolModal v-model="showPoolModal" :entryDisabled="entryDisabled" :isEditMode="editMode"
                                  :macPool="macPool"/>
                <ConfirmPoolDeletionModal v-model="showDeletionModal" entityType="MAC-pool" :macPool="macPool"/>
                <MacPoolReservationRequestModal v-model="showReservationRequestModal" :macPool="macPool"
                                                :availableMacsForCurrentUserToday="availableMacsForCurrentUserToday"/>


            </v-toolbar>

            <v-divider></v-divider>


            <v-toolbar flat color="white" v-if="error" style="margin-top: 20px">
                <v-spacer></v-spacer>


                <v-alert :value="error" type="error" transition="scale-transition">
                    {{ errorMessage }}

                    <v-btn small flat icon color="white" @click="closeAlert">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>

                </v-alert>
            </v-toolbar>

            <v-card flat>

                <v-data-table :headers="headers" hide-actions :items="macPools" :search="search" class="datatable">
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td class="text-xs-left">{{ props.item.poolId }}</td>
                            <td class="text-xs-left">{{ props.item.oui }}</td>
                            <td class="text-xs-left">{{ props.item.name }}</td>
                            <td class="text-xs-left" v-if="props.item.isActive">
                                <v-icon color="green" small>fas fa-circle</v-icon>
                            </td>
                            <td class="text-xs-left" v-else>
                                <v-icon color="red" small>fas fa-circle</v-icon>
                            </td>
                            <td class="text-xs-left">
                                <v-progress-linear v-if="props.item.availableInPercent <= upperErrorBound"
                                                   v-model="props.item.availableInPercent"
                                                   color="red"></v-progress-linear>
                                <v-progress-linear
                                        v-else-if="props.item.availableInPercent <= upperWarningBound"
                                        v-model="props.item.availableInPercent"
                                        color="orange"></v-progress-linear>
                                <v-progress-linear v-else v-model="props.item.availableInPercent"
                                                   color="green"></v-progress-linear>
                                {{props.item.available}} / {{props.item.capacity}}
                                ({{props.item.availableInPercent}} %)
                            </td>
                            <td class="text-xs-left">{{ props.item.nextMac }}</td>
                            <td class="text-xs-left">
                                <v-btn :id="'edit_pool_button_' + props.index" color="green" dark small @click="editMacPool(props.item)">
                                    <v-icon v-if="isUpdateEnabled(props.item.poolGroups)" class="mr-2">edit</v-icon>
                                    <v-icon v-else class="mr-2">far fa-eye</v-icon>
                                </v-btn>

                                <v-btn :id="'delete_pool_button_' + props.index" color="red" dark small
                                       @click="onDeleteMacPoolItem(props.item)"
                                       v-if="isDeleteEnabled(props.item.poolGroups)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                                <v-btn :id="'reserve_pool_button_' + props.index" v-if="isReserveEnabled(props.item.poolGroups)" color="rgb(70, 70, 75)" dark small
                                       class="text-none"
                                       @click="onReserveMacPoolDialog(props.item)">
                                    Reserve
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </v-data-table>
            </v-card>


        </v-app>
    </div>

</template>


<script>

    import ShowMacPoolModal from './modals/ShowMacPoolModal.vue';
    import MacPoolReservationRequestModal from './modals/MacPoolReservationRequestModal.vue';
    import poolinterface from '../../interfaces/poolinterface';
    import {EventBus} from "../../eventbus";
    import ConfirmPoolDeletionModal from "./modals/ConfirmPoolDeletionModal"
    import userinterface from "../../interfaces/userinterface";

    export default {
        name: "MacPoolList",

        components: {
            ShowMacPoolModal,
            ConfirmPoolDeletionModal,
            MacPoolReservationRequestModal
        },

        props: {
            upperWarningBound: Number,
            upperErrorBound: Number
        },

        data: () => ({
            search: "",

            headers: [
                {text: '#', value: 'pooIid', sortable: true},
                {text: 'OUI', value: 'oui', sortable: true},
                {text: 'Company', value: 'company', sortable: true},
                {text: 'Is Active', value: 'isActive', sortable: true},
                {text: 'Available', value: 'available', sortable: true},
                {text: 'NextMAC', value: 'nextMac', sortable: true},
                {text: 'Options', value: 'name', sortable: false}
            ],

            macPools: [],

            macPool: {
                poolId: null,
                oui: null,
                name: null,
                description: null,
                startMac: null,
                endMac: null,
                nextMac: null,
                isActive: false,
                macsPerReq: null,
                macsPerUserDay: null,
                rowVersion: null
            },

            emptyMacPool: {
                poolId: null,
                oui: null,
                name: null,
                description: null,
                startMac: null,
                endMac: null,
                nextMac: null,
                isActive: false,
                macsPerReq: null,
                macsPerUserDay: null,
                rowVersion: null
            },

            rights: [],
            createPool: false,
            deletePool: false,
            updatePool: false,
            reservePool: false,
            protocolRead: false,

            error: false,
            errorMessage: null,

            showPoolModal: false,
            showEditPoolModal: false,
            showDeletionModal: false,
            showReservationRequestModal: false,
            editMode: false,
            availableMacsForCurrentUserToday: 0,
            entryDisabled: false
        }),

        created() {
            this.initialize();
            this.initializeRights();
        },

        mounted() {
            EventBus.$on('macPoolDialogClosed', () => {
                this.initialize();
                this.macPool = Object.assign({}, this.emptyMacPool);
                this.editMode = false;
            });
            EventBus.$on('reservationResponseDialogClosed', () => {
                this.initialize();
            });
            EventBus.$on('macPoolDeletionClosed', () => {
                this.initialize();
                this.macPool = Object.assign({}, this.emptyMacPool);
                this.showDeletionModal = false;
            });
            EventBus.$on('macPoolDeletionConfirmed', () => {
                this.initialize();
                this.macPool = Object.assign({}, this.emptyMacPool);
                this.showDeletionModal = false;
            });
            EventBus.$on('macReservationClosed', () => {
                this.initialize();
                this.macPool = Object.assign({}, this.emptyMacPool);
                this.showReservationRequestModal = false;
            });
        },

        methods: {
            createMacPool() {
                this.macPool = Object.assign({}, this.emptyMacPool);
                this.editMode = false;
                this.showPoolModal = true;
            },

            editMacPool(macPool) {
                this.macPool = Object.assign({}, macPool);
                this.editMode = true;
                this.showPoolModal = true;
                this.entryDisabled = !this.isUpdateEnabled(macPool.poolGroups);
            },

            onDeleteMacPoolItem(macPool) {
                this.macPool = Object.assign({}, macPool);
                this.showDeletionModal = true;
            },

            async onReserveMacPoolDialog(macPool) {
                await poolinterface.getAvailableMacsForPoolAndUser(macPool, response => {
                    this.availableMacsForCurrentUserToday = response.remainingMacPerUserDay
                });

                this.macPool = Object.assign({}, macPool);
                EventBus.$emit('openReservationRequestDialog');
                this.showReservationRequestModal = true;
            },

            async initialize() {
                await poolinterface.getMacPools(pools => {
                    this.macPools = pools;
                });

                await userinterface.updateCurrentUserRights();
            },

            initializeRights() {
                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "PoolModify") {
                        this.createPool = true;
                    }

                    if (right.right === "PoolReserve") {
                        this.reservePool = true;
                    }

                    if (right.right === "ProtocolEntryRead") {
                        this.protocolRead = true;
                    }

                });
            },

            isDeleteEnabled(poolGroups) {
                let deleteEnabled = false;

                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    poolGroups.forEach(poolGroup => {
                        if (right.right === "PoolGroupDelete" && right.referenceId === poolGroup.poolGroupId) {
                            deleteEnabled = true;
                        }
                    });

                });

                return deleteEnabled;
            },

            isReserveEnabled(poolGroups) {
                let deleteEnabled = false;

                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    poolGroups.forEach(poolGroup => {
                        if (right.right === "PoolGroupReserve" && right.referenceId === poolGroup.poolGroupId) {
                            deleteEnabled = true;
                        }
                    });

                });

                return deleteEnabled;
            },

            isUpdateEnabled(poolGroups) {
                let updateEnabled = false;

                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "PoolModify") {
                        updateEnabled = true;
                        return true;
                    }

                    poolGroups.forEach(poolGroup => {
                        if (right.right === "PoolGroupUpdate" && right.referenceId === poolGroup.poolGroupId) {
                            updateEnabled = true;
                        }
                    });
                });

                return updateEnabled;
            },

            closeAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    };
</script>

<style>
    
</style>


// WEBPACK FOOTER //
// src/components/macpools/MacPoolList.vue